module.exports = __webpack_public_path__ + "static/img/2.d223d0d.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/img_right_icon/2.png
// module id = w55N
// module chunks = 1